<template>
  <div class="login-box">
    <div class="card card-outline card-primary">
      <div class="card-header text-center">
        <router-link class="h1" to="/login">
          <b>{{ appName }}</b>
        </router-link>
      </div>

      <div class="card-body login-card-body" v-if="!showNewPasswordForm">
        <p class="login-box-msg">Sign in to start your session</p>

        <ol v-if="!isProd">
          <li v-for="user in users" v-bind:key="user.username">
            <b-button :variant="username === user.username ? 'primary' : 'default'"
                      size="sm"
                      @click="() => { fillForm(user.username, user.password) }"
            >{{ user.username }}: {{ user.password }}</b-button>
          </li>
        </ol>

        <form @submit.prevent="doLogin">
          <div class="input-group mb-3">
            <input type="text" class="form-control" placeholder="Login" v-model="username" required>
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-user"></span>
              </div>
            </div>
          </div>
          <div class="input-group mb-3">
            <input type="password" class="form-control" placeholder="Password" v-model="password" required>
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-lock"></span>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-8 col-sm-2">
              <a class="btn btn-link" v-on:click.prevent="$router.push('/forgot-password');" href="/forgot-password">Forgot password?</a>
            </div>
            <div class="col-md-4 col-sm-10">
              <button type="submit" class="btn btn-primary btn-block">Sign In</button>
            </div>
          </div>
        </form>

<!--        <p class="mb-1">-->
<!--          <router-link to="/forgot-password">{{ $t('I forgot my password') }}</router-link>-->
<!--        </p>-->
      </div>
      <div v-else class="card-body login-card-body">
        <p class="login-box-msg">Enter new password</p>

        <form @submit.prevent="doUpdatePassword">
          <div class="form-group">
            <b-form-input
              id="password-input"
              name="password-input"
              v-model="newPassword"
              v-validate="{ required: true, min: 8, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])([a-zA-Z\d]|[^A-Za-z\d]){8,}$/ }"
              :state="validateState('password-input')"
              aria-describedby="password-input-live-feedback"
              autocomplete="off"
              data-vv-as="Password"
              placeholder="New Password"
              ref="password"
            />
            <b-form-invalid-feedback id="password-input-live-feedback">{{ veeErrors.first('password-input') }}. Password must contain a number, at least one special character, one capital and one lowercase letter.</b-form-invalid-feedback>
          </div>
          <div class="form-group">
            <b-form-input
              id="password-confirm-input"
              name="password-confirm-input"
              v-model="newPasswordConfirmation"
              v-validate="'required|confirmed:password'"
              :state="validateState('password-confirm-input')"
              aria-describedby="password-confirm-input-live-feedback"
              data-vv-as="Password"
              autocomplete="off"
              placeholder="Confrim New Password"
            />
            <b-form-invalid-feedback id="password-confirm-input-live-feedback">{{ veeErrors.first('password-confirm-input') }}</b-form-invalid-feedback>
          </div>
          <div class="row mb-3">
            <div class="col-md-12 col-sm-12">
              <button type="submit" class="btn btn-success btn-block">Update Password</button>
            </div>
          </div>
        </form>

      </div>

    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Axios from "axios";

export default {
  name: 'Login',
  components: {},
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    doUpdatePassword: function () {
      this.$http({
        url: '/api/v1/users/update-password',
        data: {
          username: this.username,
          password: this.password,
          newPassword: this.newPassword,
          newPasswordConfirm: this.newPasswordConfirmation,
        },
        method: 'POST'
      }).then(() => {
        this.password = this.newPassword;
        this.doLogin();
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.$toastr.e(error.response.data.message);
          return;
        }

        if (error.message) {
          this.$toastr.e(error.message);
        }
      });
    },
    doLogin: function () {
      let redirect = this.$route.query.redirect || null;

      this.$http({
        url: '/api/v1/token/get',
        data: {
          username: this.username,
          password: this.password,
        },
        method: 'POST'
      }).then(resp => {
        const token = resp.data.token;
        const refreshToken = resp.data?.refreshToken || null;

        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('username', this.username);

        Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

        this.$store.commit('AUTH_SUCCESS', {
          token: token,
          username: this.username,
        });

        this.$store.dispatch('loadApplicationData');

        this.$toastr.removeByName('idleTimeoutNotification');

        if (redirect) {
          this.$router.push(redirect)
        } else {
          this.$router.push('/welcome')
        }

      }).catch((error) => {
        this.showNewPasswordForm = false;
        window.error = error;
        if (error.response && error.response.data) {
          this.$toastr.e(error.response.data.message);
          if (error.response.data.code === 2) {
            this.showNewPasswordForm = true;
            return;
          }
          return;
        }

        if (error.message) {
          this.$toastr.e(error.message);
        }
      });
    },
    fillForm: function (username, password) {
      this.username = username;
      this.password = password;
    },
  },
  computed: {
    ...mapGetters([
      'getCurrentUser',
    ]),
  },
  created() {
    if (this.getCurrentUser) {
      this.$toastr.removeByName('idleTimeoutNotification');
      this.$router.push('/welcome');
    }
  },
  watch: {
    getCurrentUser(newValue) {
      if (newValue) {
        this.$toastr.removeByName('idleTimeoutNotification');
        this.$router.push('/welcome');
      }
    },
  },
  mounted () {
    if (!this.isProd) {
      let user = this.users[0];

      this.username = user.username;
      this.password = user.password;
    }

    if (this.getCurrentUser) {
      this.$toastr.removeByName('idleTimeoutNotification');
      this.$router.push('/welcome');
    }

    this.appElement = document.getElementById('application');
    this.appElement.classList.add('login-page');

    if (localStorage.getItem('idleTimeoutMessage')) {
      let warning = {
        name: 'idleTimeoutNotification',
        msg: localStorage.getItem('idleTimeoutMessage'),
        type: "warning",
        preventDuplicates: true,
        timeout: 0,
      };

      this.$toastr.Add(warning);
      localStorage.removeItem('idleTimeoutMessage');
    }
  },
  beforeDestroy() {
    this.appElement.classList.remove('login-page')
  },
  data(){
    return {
      appElement: null,
      username: null,
      password: null,
      appName: process.env.VUE_APP_NAME,
      isProd: process.env.VUE_APP_ENV === 'prod',
      users: [{username: 'admin', password: 'passwP1P'}],
      newPassword: null,
      newPasswordConfirmation: null,
      showNewPasswordForm: false
    }
  },
}
</script>
